import { render } from "./Fallback.vue?vue&type=template&id=a7e25c9e"
import script from "./Fallback.vue?vue&type=script&lang=ts"
export * from "./Fallback.vue?vue&type=script&lang=ts"
script.render = render

export default script